import { render } from "./RolesEditor.vue?vue&type=template&id=08238cec&scoped=true"
import script from "./RolesEditor.vue?vue&type=script&lang=js"
export * from "./RolesEditor.vue?vue&type=script&lang=js"

import "./RolesEditor.vue?vue&type=style&index=0&id=08238cec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08238cec"]])

export default __exports__